import axios from 'axios';

export async function storeSessionPage(pageObj) {
  try {
    const res = await axios.post(
      `/session-pages`,
      { pageObj },
    );
    return res.data;
  } catch (err) {
    console.error(err);
  }
}

export async function saveSessionEnd(clearSession) {
  try {
    const res = await axios.post('/session-end', { clearSession });
    return res.data;
  } catch (err) {
    console.error(err);
  }
}

export async function setPageId(pageObj) {
  try {
    const res = await axios.post(
      `/session-pages`,
      { pageObj },
    );
    return res.data;
  } catch (err) {
    console.error(err);
  }
}

export const createReservationCheckInRating = async (ratingId) => {
  return (await axios.post(`/reservation-check-in-rate`, { ratingId })).data
}

export const setReservationCheckInRatingObservations = async (observations) => {
  return (await axios.post(`/reservation-check-in-rate/observations`, { observations })).data
}

export async function savePackBasicAction(value) {
  try {
    const res = await axios.post(
      `/pack-basic-response`,
      {
        accept: value
      }
    );
    return res.data;
  } catch (err) {
    console.error(err);
  }
}
